import capitalize from 'lodash/capitalize';
import flow from 'lodash/flow';
import get from 'lodash/get';
import { getMailboxLabel, getMailboxDescription, getCertificateLabel } from './specs';
const format = str => str.split(/[_-]/).map(capitalize).join('').replace('alone', 'Alone');
export const computeProductComponentName = product => [product.productType, product.process].filter(Boolean).map(format).join('');
export const decorators = {
  product: product => {
    const component = computeProductComponentName(product);
    const {
      prices
    } = product;
    const label = product.payload?.label || `${product.productType} - ${product.process}`;
    const hasPrices = Array.isArray(prices) && prices.length;
    let unitPrice = product.unitPrice;
    let hasTaxes = false;
    let discounts = [];
    if (hasPrices) {
      if (product.unitPrice === undefined) {
        unitPrice = prices[0].base_price;
      }
      const taxes = prices[0].taxes;
      hasTaxes = Array.isArray(taxes) && taxes.filter(tax => tax.name !== 'notax').length > 0;
      const discountPrices = prices.filter(price => price.item_type === 'discount');
      if (discountPrices.length > 0) {
        discounts = discountPrices.map(discount => ({
          description: discount.discount_code ?? discount.description,
          amount: discount.base_price
        }));
      }
    }
    const isValid = product.status === 'success';
    return {
      ...product,
      label,
      isValid,
      unitPrice,
      hasTaxes,
      discounts,
      component
    };
  },
  domain: product => {
    const label = product.payload.fqdn || product.identifier || '';
    return {
      ...product,
      label,
      fqdn: label
    };
  },
  paas: product => {
    const label = product.payload.label || `${get(product.payload, 'type.language.name', '')}/${get(product.payload, 'type.database.name', '')} - ${get(product.payload, 'size', '').toUpperCase()}`;
    return {
      ...product,
      label
    };
  },
  cloud: product => {
    const label = product.payload.label || `${product.productType} - ${product.process}`;
    return {
      ...product,
      label
    };
  },
  mailboxv2: product => {
    const mailboxType = get(product, 'payload.mailbox_type') || get(product, 'description', 'standard');
    const expirationDate = get(product, 'prices.0.date_end');
    return {
      ...product,
      label: getMailboxLabel(mailboxType),
      description: getMailboxDescription(mailboxType),
      fqdn: product.payload.fqdn,
      mailboxType,
      expirationDate
    };
  },
  certificate: product => {
    const label = getCertificateLabel(product.payload.options);
    return {
      ...product,
      label
    };
  },
  domain_option: product => {
    const component = product.payload.option === 'premium_dns' ? `PremiumDNS${format(product.process)}` : product.component;
    return {
      ...product,
      fqdn: product.identifier,
      component,
      expirationDate: get(product, 'prices.0.date_end')
    };
  }
};
const noop = obj => obj;
const decoratedProductCache = new WeakMap();
export const applyDecoratorsOnProduct = product => {
  if (decoratedProductCache.has(product)) {
    const cachedProduct = decoratedProductCache.get(product);
    if (cachedProduct !== undefined) {
      return cachedProduct;
    }
  }
  const productDecorators = ['product', product.productType].map(name => decorators[name] || noop);
  const decoratedProduct = flow(productDecorators)(product);
  decoratedProductCache.set(product, decoratedProduct);
  return decoratedProduct;
};